import React, { useState, useEffect } from 'react';
import "./SuiviTransmission.css"
import Navbar from '../../appShell/Navbar/Navbar'
import Sidebar from '../../appShell/Sidebar/Sidebar'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Navigate, useNavigate } from 'react-router-dom';
import { handleMenuSelection, handleSubMenuSelection } from '../../utils/utils';
import Select from "react-select";
import CustomDatatableSuiviTaux from '../../components/CustomDatatableSuiviTaux/CustomDatatableSuiviTaux';
import { FiFilter } from "react-icons/fi"
import { ImMakeGroup } from "react-icons/im"
import { FaClipboardList } from "react-icons/fa"
import CustomDatatableSuiviTransmission from '../../components/CustomDatatableSuiviTransmission/CustomDatatableSuiviTransmission';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';
import { getSuiviTransmissionList, getSuiviTransmissionParams } from '../../services/http';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';


const SuiviTransmission = () => {


    const dispatch = useDispatch();
    const [pageNumber, setPageNumber] = useState(1);
    const [perPage, setPerPage] = useState(15);
    const [totalPage, setTotalPage] = useState(1);

    const states = useSelector((state) => state, shallowEqual);
    const navigate = useNavigate();

    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    registerLocale('fr', fr);
    const [etablissements, setEtablissements] = useState([]);
    const [institution, setInstitution] = useState();
    const [statut, setStatut] = useState();

  const [displayLoader, setDisplayLoader] = useState(true);

    // To populate the breadcrumb and update the sidebar menu
    useEffect(async () => {
        dispatch({
            type: "SET",
            key: "breadcrumbContent",
            payload: {
                firstLevelText: "Suivi", firstLevelLink: "/suivi-transmission", secondLevelText: "Transmission", secondLevelLink: "/suivi-transmission", thirdLevelText: "", thirdLevelLink: ""
            }
        });
        handleMenuSelection("monitoring", dispatch, states);
        handleSubMenuSelection("suivi-transmission", dispatch)
    }, [])

    useEffect(async () => {
        // To fulfill filters
        const suivi_transmission_params_response = await getSuiviTransmissionParams(states.userToken.access_token)
        if (suivi_transmission_params_response.response && suivi_transmission_params_response.response.statut !== 200) {
            console.log(suivi_transmission_params_response.response)
        } else {
            console.log(suivi_transmission_params_response)
            setEtablissements(suivi_transmission_params_response.data?.institution)
        }

        // To set filter by default
        const actualDate = new Date();
        const actualYear = actualDate.getFullYear();

        const data = {
            "institution": states.userInfo.institution ? states.userInfo.institution.id : "",
            "debut": actualYear + "-" + "01",
            "fin": actualYear + "-" + "12"
        }
        console.log(data)
        const suivi_transmission_list_response = await getSuiviTransmissionList(data, states.userToken.access_token, pageNumber)
        if (suivi_transmission_list_response.response && suivi_transmission_list_response.response.statut !== 200) {
            console.log(suivi_transmission_list_response.response.data.error)
            // const errorMsg = suivi_transmission_list_response.response.data.error;
            // toast.error(errorMsg, {
            //     position: toast.POSITION.TOP_RIGHT
            // });
        } else {
            console.log(suivi_transmission_list_response)
            const total = suivi_transmission_list_response?.data?.total;
            const perPageValue = suivi_transmission_list_response?.data?.per_page
            // setTotalPage(Math.ceil(total / perPageValue))
            // setPerPage(perPageValue)
            // dispatch({
            //     type: "SET",
            //     key: "suiviTransmissionList",
            //     payload: suivi_transmission_list_response.data.data,
            // });
            // setDisplayLoader(false);
        }
    }, [])

    const handleChangeEntry = (key, e) => {
        const value = e.currentTarget.value;
        if (key == "etablissement") {
            setInstitution(value)
        }
        if (key == "statut") {
            setStatut(value)
        }
    }

    const handleApplyFilter = async (type) => {
        if(type == "filter"){
            setPageNumber(1)
        }
        const actualDate = new Date();
        const actualYear = actualDate.getFullYear();

        console.log(dateRange[1]?.getFullYear())
        const deb = dateRange[0]?.getMonth() + 1;
        const fin = dateRange[1]?.getMonth() + 1;
        const dateDebut = dateRange[0]?.getFullYear() + "-" + (deb < 10 ? "0" + deb : deb);
        const dateFin = dateRange[1]?.getFullYear() + "-" + (fin < 10 ? "0" + fin : fin);
        const data = {
            "institution": institution == undefined ? "" : institution,
            "statut": statut == undefined || statut == "Toutes" ? "" : statut,
            "debut": dateDebut !== "undefined-NaN" ? dateDebut : actualYear + "-" + "01",
            "fin": dateFin !== "undefined-NaN" ? dateFin : actualYear + "-" + "12"
        }

        console.log("filter", data);
        const suivi_transmission_list_response = await getSuiviTransmissionList(data, states.userToken.access_token, pageNumber)
        if (suivi_transmission_list_response.response && suivi_transmission_list_response.response.statut !== 200) {
            console.log(suivi_transmission_list_response.response.data.error)
            const errorMsg = suivi_transmission_list_response.response.data.error;
            toast.error(errorMsg, {
                position: toast.POSITION.TOP_RIGHT
            });
        } else {
            console.log(suivi_transmission_list_response.data)
            const total = suivi_transmission_list_response?.data?.total;
            const perPageValue = suivi_transmission_list_response?.data?.per_page
            setTotalPage(Math.ceil(total / perPageValue))
            setPerPage(perPageValue)
            dispatch({
                type: "SET",
                key: "suiviTransmissionList",
                payload: suivi_transmission_list_response.data?.data,
            });
            setDisplayLoader(false);
        }
    }

    useEffect(() => {
        handleApplyFilter("no-filter")
    }, [pageNumber]);

    const tableColumns = [
        { id: "1", label: "#" },
        { id: "2", label: "Mois" },
        { id: "3", label: "Année" },
        { id: "4", label: "Date de transmission" },
        { id: "5", label: "Statut" },
        { id: "5", label: "Etablissement" },
    ]

    const statusOptions = [
        { value: "Toutes", label: "Toutes"},
        { value: "Transmis", label: 'Transmis' },
        { value: "Transmis en retard", label: 'Transmis en retard' },
        { value: "Transmis très en retard", label: 'Transmis très en retard' },
    ];

  

    const changePage = ({ selected }) => {
        let currentPage = selected + 1;
        setPageNumber(currentPage)
    }

    return (
        <div>
            <Navbar />
            <div className="main-container" id="container">
                <Sidebar />

                <div id="content" className="main-content">
                {displayLoader == false ?
                    <div className="layout-px-spacing">

                        <div className="row layout-top-spacing">
                            <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                            </div>
                        </div>
                        <h2 className="mb-3 text-left">Suivi des transmissions</h2>
                        <div className="widget widget-content widget-content-area p-3 mb-3">
                            <h5 className="text-left"> <FiFilter className="pb-1 mr-1" /> Filtres</h5>
                            <hr />
                            <div className=" d-flex justify-content-around flex-wrap">
                            <div className="col-sm-3 col-xs-12 mb-2">
                                        <div>Etablissement</div>
                                <select onChange={(e) => handleChangeEntry("etablissement", e)} className={"form-control custom-form-control basic"}>
                                    <option disabled selected hidden value="">  </option>
                                    {etablissements !== [] && etablissements?.map((item) => (
                                        <option key={item.id} value={item.id}>{item.libelle}</option>
                                    ))}
                                </select>
                                </div>
                                <div className="col-sm-3 col-xs-12 mb-2">
                                        <div>Statut</div>
                                <select onChange={(e) => handleChangeEntry("statut", e)} className={"form-control custom-form-control basic"}>
                                    <option disabled selected hidden value="">  </option>
                                    {statusOptions !== [] && statusOptions?.map((item) => (
                                        <option key={item.value} value={item.value}>{item.label}</option>
                                    ))}
                                </select>
                                </div>


                                <div className={"col-sm-4 col-xs-12 mb-2"}>
                                <div className='truncate'>Mois(Début) - Mois(Fin)</div>
                                    <DatePicker
                                        selectsRange={true}
                                        startDate={startDate}
                                        endDate={endDate}
                                        dateFormat="MM/yyyy"
                                        locale="fr"
                                        onChange={(update) => {
                                            setDateRange(update);
                                        }}
                                        isClearable={true}
                                        placeholderText=""
                                        showMonthYearPicker
                                        showFullMonthYearPicker
                                        className={"form-control custom-form-control basic"}
                                        onChangeRaw={(e) => e.preventDefault()}
                                    />
                                </div>

                                <div className="col-xs-12 d-flex align-items-center">
                               
                                <button style={{ height: "45px" }} className="btn btn-dark mt-2" onClick={() => handleApplyFilter("filter")}>Appliquer</button>
                                </div>

                            </div>
                        </div>



                        <div className="widget widget-content widget-content-area  pb-3 mb-3">
                            <h5 className="text-left p-3"> <FaClipboardList className="pb-1 mr-2" />Liste des transmissions</h5>
                            <p className="suivi-taux-total-number text-gray text-left pl-3">{states.suiviTransmissionList?.length <= 1 ? `${states.suiviTransmissionList?.length} élément` : `${states.suiviTransmissionList?.length} éléments`}</p>
                            {/* Start Custom Datatable */}

                            {states.suiviTransmissionList && states.suiviTransmissionList?.length !== 0 ?
                                <CustomDatatableSuiviTransmission
                                    columns={tableColumns}
                                    changePage={changePage}
                                    pageCount={totalPage}
                                    pageNumber={pageNumber}
                                    perPage={perPage}
                                    data={states.suiviTransmissionList}
                                /> : <h4 className="py-3">Aucun résultat</h4>}

                            {/* End Custom Datatable */}
                        </div>

                    </div> : <div style={{ marginTop: "25%" }}>
                  <Loader />
                </div>}


                </div>
            </div>
        </div>
    )
}

export default SuiviTransmission